
import { types } from "../types"


export const getProfile = () => {
    return {
        type: types.GET_PROFILE_REQUEST,

    }
}

export const updateProfile = (params) => {
    return {
        type: types.UPDATE_PROFILE_REQUEST,
        params
    }
}


export const changePassword = (params) => {

    return {
        type: types.CHANGE_PASSWORD_REQUEST,
        params
    }
}

export const uploadProfilePhoto = (params) => {
    return {
        type: types.UPLOAD_PROFILE_PHOTO_REQUEST,
        params
    }
}

export const getProfilePhoto = (userName) => {
    return {
        type: types.GET_PROFILE_PHOTO_REQUEST,
        userName
    }
}

export const resetProps = (params) => {
    return {
        type: types.PROFILE_RESET_PROPS,
        params
    }
}

